import styled from 'styled-components';
export const Container = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  gap: .5rem;
  justify-content: center;
  align-items: center;
  flex-direction: row;
`;
export const Controls = styled.div`
  display: flex;
  height: 100%;
  min-width: 9rem;
  justify-content: space-around;
  flex-direction: column;
  padding: .2rem;
  gap: .3rem;

  > div {
    display: flex;
    flex-direction: column;
    gap: .3rem;
    align-items: center;
    justify-content: center;
  }

  button {
    outline: none;
    border: none;
    width: 3rem;
    height: 2.5rem;
    cursor: pointer;
    border-radius: 4px;
    background-color: #1D86FF;
    color:#ffffff;
    box-shadow: 0 4px 6px -1px rgb(0 0 0 / 10%), 0 2px 4px -1px rgb(0 0 0 / 6%);
    &:hover{
      opacity: 0.9;
    }
  }
  .save{
    width: 100%;
  }
`;
export const Box = styled.div`
  width: 100%;
  height: 100%;
  min-width: 300px;
  padding: .5rem;
  border-radius: 6px;
  > span {
    display: flex;
    height: 2rem;
    width: 100%;
    justify-content: center;
    font-size: 14px;
    line-height: 20px;
    color: rgb(73, 80, 87);
    user-select: none;
  }
  > .sehF {
    height: 2.3rem;
    max-width: 450px;
    border-radius: 4px;
    background: transparent;
    border: solid 1px #e8e8e8;
  }
  .selected {
    background: #1D86FF1a;
  }
  ul {
    display: flex;
    width: 100%;
    height: calc(100% - 4.8rem);
    flex-direction: column;
    gap: .2rem;
    margin-top: 5px;
    border-radius: 6px;
    padding: 0.5rem 0 0 0;
    overflow: hidden;
    overflow-y: scroll;
    &::-webkit-scrollbar{
      width: 5px;
      height: 5px;
    }
    &::-webkit-scrollbar-thumb{
      background-color: rgb(0, 0, 0,0.2);
    }
    > li {
      display: flex;
      user-select: none;
      cursor: pointer;
      border-bottom: 1px solid rgb(218, 220, 224);
      &:hover{
        background-color: #1D86FF1a;
        border-radius: 4px;
      }
    }
  }
`;
export const User = styled.div`
  display: flex;
  width: 100%;
  min-height: 3rem;
  border-radius: 4px;
  padding: 0.2rem;
  align-items: center;
  .avUs{
    width: 2.5rem;
    height: 2.5rem;
    min-height: 0px;
    min-width:0px;
    border-radius: 4px;
  }
  > .name {
    width: calc(100% - 2.8rem);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-left: .5rem;
    font-weight: 500;
    color: black;
    font-size: 1rem;
  }
`;
export const LoadingProgress = styled.div`
    position: fixed;
    display: ${({ isOpen }) => isOpen ? 'flex' : 'none'};
    top:0px;
    left: 0px;
    width: 100%;
    height: 100%;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    cursor: default;
    animation: ModalShow .1s ease-out;
    user-select: none;
    background-color: #00000040;
    > div {
        width: 400px;
        height: 400px;
        display: flex;
        border-radius: 6px;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: #ffffff;
        gap: 2rem;
        > div > img{
            max-width: 200px;
        }
        > div:nth-child(2){
            max-width: 200px;
        }
        .loader {
            width: 50px;
            aspect-ratio: 1;
            display: grid;
            border: 4px solid #0000;
            border-radius: 50%;
            border-right-color: #25b09b;
            animation: l15 1s infinite linear;
        }
        .loader::before,
        .loader::after {    
            content: "";
            grid-area: 1/1;
            margin: 2px;
            border: inherit;
            border-radius: 50%;
            animation: l15 2s infinite;
        }
        .loader::after {
            margin: 8px;
            animation-duration: 3s;
        }
        @keyframes l15{ 
            100%{transform: rotate(1turn)}
        }
    }

    @keyframes ModalShow{
        0% {
            opacity: 0;
            transform: scale(1.2);
        }
        100% {
            opacity: 0;
            transform: scale(1);
        }
    };
`;